<template>
  <div>
    <div class="r1-div">
      <div class="r1-1-div">
        {{ $t("车辆详情页右侧.登录后查询价格") }}<br />
      </div>
      <!-- {{ $t("车辆详情页右侧.不含增值税价格") }}<br /> -->
      <a-button
        size="large"
        style="background-color: #04af04 !important"
        class="r1-1-Btn"
        @click="clickQuotation"
        >{{ $t("车辆详情页右侧.查询") }}</a-button
      >
    </div>
    <div class="r2-div">
      <p>{{ $t("车辆详情页右侧.如需帮助请拨打") }}</p>
      <p>
        <span class="r1-span">
          <svg
            version="1.1"
            id="svgHeadset"
            class="svgHeadset r1-svg"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            style="enable-background: new 0 0 512 512"
            xml:space="preserve"
          >
            <g>
              <g>
                <path
                  d="M471.059,206.77c-5.551-3.577-11.446-6.495-17.578-8.741C444.032,97.38,359.078,18.348,256,18.348
			c-103.077,0-188.031,79.031-197.481,179.68c-6.129,2.244-12.022,5.162-17.568,8.735C15.309,223.273,0,251.321,0,281.792v28.821
			c0,49.181,40.012,89.194,89.194,89.194h20.112c15.626,0,28.339-12.713,28.339-28.34v-150.53c0-15.626-12.713-28.34-28.339-28.34
			H89.194c-0.503,0-1.004,0.019-1.507,0.026C99.423,110.241,170.423,46.687,256,46.687s156.577,63.553,168.313,145.938
			c-0.503-0.008-1.004-0.026-1.507-0.026h-20.112c-15.626,0-28.339,12.713-28.339,28.339v150.53
			c0,15.626,12.713,28.339,28.339,28.339h19.032c-11.949,37.926-47.446,65.505-89.267,65.505c-7.825,0-14.17,6.344-14.17,14.17
			s6.344,14.17,14.17,14.17c59.326,0,108.88-42.6,119.703-98.814C486.966,382.672,512,349.514,512,310.613v-28.821
			C512,251.321,496.693,223.274,471.059,206.77z M89.194,220.938h20.112l0.018,150.529c0,0-0.006,0.001-0.018,0.001H89.194
			c-33.555,0-60.854-27.299-60.854-60.854v-28.821c0-20.792,10.45-39.931,27.958-51.204
			C66.094,224.275,77.47,220.938,89.194,220.938z M483.661,310.613c0,33.555-27.298,60.854-60.854,60.854h-20.112v-150.53h20.112
			c11.724,0,23.101,3.338,32.907,9.657c17.5,11.267,27.947,30.406,27.947,51.197V310.613z"
                ></path>
              </g>
            </g>
          </svg>
        </span>
        <a style="color: #f2f3f3">+135 0442 8433</a>
      </p>
      <p style="margin-bottom: 0px">
        {{ $t("车辆详情页右侧.拨打电话 周一至周日") }} 8:00-20:00
      </p>
    </div>
    <div>
      <img
        src="https://jf-jfweb-release-1256082024.cos.ap-beijing.myqcloud.com/img/liuzongzhaopian.jpg"
        style="width: 100%; height: auto"
      />
      <p
        style="
          font-weight: 700 !important;
          font-size: 1.25rem !important;
          padding-top: 10px;
          padding-bottom: 10px;
          text-align: center;
          border: 1px solid black;
          margin-bottom: 0px;
        "
      >
        {{ $t("车辆详情页右侧.人员姓名") }}
      </p>
    </div>
    <div
      style="
        text-align: center;
        font-weight: 700;
        font-size: 18px;
        border-width: 0px 1px 1px 1px;
        border-color: black;
        border-style: solid;
        background-color: #f8f8f8;
      "
    >
      <a>liuhui@jfrental.com</a><br />
      <!-- <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        style="
          enable-background: new 0 0 512 512;
          width: 1rem !important;
          margin-right: 5px;
        "
        xml:space="preserve"
      >
        <circle style="fill: #f0f0f0" cx="256" cy="256" r="256"></circle>
        <g>
          <path
            style="fill: #0052b4"
            d="M52.92,100.142c-20.109,26.163-35.272,56.318-44.101,89.077h133.178L52.92,100.142z"
          ></path>
          <path
            style="fill: #0052b4"
            d="M503.181,189.219c-8.829-32.758-23.993-62.913-44.101-89.076l-89.075,89.076H503.181z"
          ></path>
          <path
            style="fill: #0052b4"
            d="M8.819,322.784c8.83,32.758,23.993,62.913,44.101,89.075l89.074-89.075L8.819,322.784L8.819,322.784
		z"
          ></path>
          <path
            style="fill: #0052b4"
            d="M411.858,52.921c-26.163-20.109-56.317-35.272-89.076-44.102v133.177L411.858,52.921z"
          ></path>
          <path
            style="fill: #0052b4"
            d="M100.142,459.079c26.163,20.109,56.318,35.272,89.076,44.102V370.005L100.142,459.079z"
          ></path>
          <path
            style="fill: #0052b4"
            d="M189.217,8.819c-32.758,8.83-62.913,23.993-89.075,44.101l89.075,89.075V8.819z"
          ></path>
          <path
            style="fill: #0052b4"
            d="M322.783,503.181c32.758-8.83,62.913-23.993,89.075-44.101l-89.075-89.075V503.181z"
          ></path>
          <path
            style="fill: #0052b4"
            d="M370.005,322.784l89.075,89.076c20.108-26.162,35.272-56.318,44.101-89.076H370.005z"
          ></path>
        </g>
        <g>
          <path
            style="fill: #d80027"
            d="M509.833,222.609h-220.44h-0.001V2.167C278.461,0.744,267.317,0,256,0
		c-11.319,0-22.461,0.744-33.391,2.167v220.44v0.001H2.167C0.744,233.539,0,244.683,0,256c0,11.319,0.744,22.461,2.167,33.391
		h220.44h0.001v220.442C233.539,511.256,244.681,512,256,512c11.317,0,22.461-0.743,33.391-2.167v-220.44v-0.001h220.442
		C511.256,278.461,512,267.319,512,256C512,244.683,511.256,233.539,509.833,222.609z"
          ></path>
          <path
            style="fill: #d80027"
            d="M322.783,322.784L322.783,322.784L437.019,437.02c5.254-5.252,10.266-10.743,15.048-16.435
		l-97.802-97.802h-31.482V322.784z"
          ></path>
          <path
            style="fill: #d80027"
            d="M189.217,322.784h-0.002L74.98,437.019c5.252,5.254,10.743,10.266,16.435,15.048l97.802-97.804
		V322.784z"
          ></path>
          <path
            style="fill: #d80027"
            d="M189.217,189.219v-0.002L74.981,74.98c-5.254,5.252-10.266,10.743-15.048,16.435l97.803,97.803
		H189.217z"
          ></path>
          <path
            style="fill: #d80027"
            d="M322.783,189.219L322.783,189.219L437.02,74.981c-5.252-5.254-10.743-10.266-16.435-15.047
		l-97.802,97.803V189.219z"
          ></path>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        style="enable-background: new 0 0 512 512; width: 1rem !important"
        xml:space="preserve"
      >
        <circle style="fill: #f0f0f0" cx="256" cy="256" r="256"></circle>
        <path
          style="fill: #0052b4"
          d="M496.077,345.043C506.368,317.31,512,287.314,512,256s-5.632-61.31-15.923-89.043H15.923
	C5.633,194.69,0,224.686,0,256s5.633,61.31,15.923,89.043L256,367.304L496.077,345.043z"
        ></path>
        <path
          style="fill: #d80027"
          d="M256,512c110.071,0,203.906-69.472,240.077-166.957H15.923C52.094,442.528,145.929,512,256,512z"
        ></path>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg> -->
    </div>
    <quotationDlg ref="quotationDlg"></quotationDlg>
  </div>
</template>

<script>
import quotationDlg from "../model/quotation.vue";
export default {
  components: { quotationDlg },
  data() {
    return {};
  },
  methods: {
    clickQuotation() {
      //if (Object.keys(this.$store.state.userInfo).length > 0) {
      this.$refs.quotationDlg.show({ type: "" });
      // } else {
      //   this.$router.push({ path: "/Login" });
      // }
    },
  },
};
</script>

<style scoped>
.r1-svg {
  width: 2.5rem !important;
  color: white !important;
  fill: white !important;
}
.r1-span {
  font-size: 2.5rem !important;
  margin-right: 1rem !important;
}
.r2-div {
  font-size: 20px;
  text-align: center;
  margin-top: 3rem !important;
  background: #04af04 !important;
  color: white !important;
  font-weight: 700 !important;
}
.r1-1-Btn {
  margin-top: 20px;
  color: #f2f3f3;
  font-size: 1.25rem;
  padding: 1rem 0.5rem;
  width: 100%;
  height: auto;
}
.r1-1-div {
  color: #ff890a !important;
  padding-right: 0.5rem !important;
  margin-bottom: 1rem !important;
  margin-top: 1rem !important;
}
.r1-div {
  font-size: 18px;
  font-weight: 700 !important;
  text-align: center;
  padding: 3rem !important;
  border: 1px solid black;
}
.layoutfork {
  flex: 2.5;
  height: auto;
  margin-left: 1.2rem;
  margin-bottom: 1.5rem;
  cursor: pointer;
}

.rowStyle {
  border-bottom: 1px solid #f2f3f3;
  padding-top: 10px;
  padding-right: 5px;
  padding-left: 5px;
  padding-bottom: 10px;
}

.text-call {
  color: #f2f3f3 !important;
  font-size: 2rem !important;
}

.div-row {
  display: flex;
  justify-content: space-around;
  width: 100%;
  flex-wrap: wrap;
}
.text-center {
  text-align: center !important;
}
</style>
